import React from 'react'
import { Switch, Route } from 'react-router-dom'
import IndexContainer from './IndexContainer'
import PersonContainer from './PersonContainer'

const Routes = () => (
  <Switch>
    <Route exact path='/'><IndexContainer /></Route>
    <Route path='/person/:darn'><PersonContainer /></Route>
  </Switch>
)

export default Routes
